import React, {useEffect, useState} from "react";
import {CommunicationPreferencesCardContainer, HeaderText} from "./CpStyles";
import {NotificationOutlined} from "@ant-design/icons";
import {List, Skeleton, Switch} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "../../../hooks/useStore";

const CommunicationPreferencesCard = () => {
    const stores = useStore();
    const {userId} = stores.meStore;
    const {t} = useTranslation(["communicationPreferences"]);
    const [dailyReminder, setDailyReminder] = useState(false);

    useEffect(() => {
        const getCommunicationPreferences = async () => {
            const resultOfRequest = await stores.userStore.getCommunicationPreferences({
                userId
            });
            setDailyReminder(
                resultOfRequest?.data?.communicationPreferences?.email?.shift?.dailyReminder
            );
        };
        getCommunicationPreferences();
    }, [userId]);

    const onChange = async checked => {
        setDailyReminder(checked);
        const preferences = {
            communicationPreferences: {
                email: {
                    shift: {
                        dailyReminder: checked
                    }
                }
            }
        };
        await stores.userStore.updateCommunicationPreferences({
            userId,
            preferences
        });
    };

    return (
        <CommunicationPreferencesCardContainer
            title={
                <h4>
                    <NotificationOutlined />
                    <HeaderText>
                        {t("communicationPreferences", {ns: "communicationPreferences"})}
                    </HeaderText>
                </h4>
            }
        >
            <List.Item
                style={{
                    display: "flex",
                    alignItems: "center",
                    // justifyContent: "flex-start",
                    gap: "20px"
                }}
            >
                <Skeleton loading={false} active>
                    <div>{t("communicationPermission", {ns: "communicationPreferences"})}</div>
                </Skeleton>
                <Switch
                    style={{
                        width: "60px",
                        backgroundColor: dailyReminder ? "#AEF001" : "#f0f0f0"
                    }}
                    checked={dailyReminder}
                    onChange={onChange}
                />
            </List.Item>
        </CommunicationPreferencesCardContainer>
    );
};

export default CommunicationPreferencesCard;
